/**
 * Sync Status Field Component
 * Multi-select dropdown for sync status filter (Completed, Failed, Cancelled)
 * Handles conversion between comma-separated string and array internally
 */

import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent, Checkbox, ListItemText } from '@mui/material'
import { SYNC_STATUS_OPTIONS } from '../types'

interface SyncStatusFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const SyncStatusField: React.FC<SyncStatusFieldProps> = ({
  value,
  onChange,
  label = 'Status',
}) => {
  const selectedValues = value ? value.split(',') : []

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const newValue = event.target.value
    const valueArray = typeof newValue === 'string' ? newValue.split(',') : newValue
    onChange(valueArray.filter(Boolean).join(','))
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select
          multiple
          displayEmpty
          value={selectedValues}
          onChange={handleChange}
          renderValue={(selected) => {
            const arr = selected as string[]
            if (arr.length === 0) return 'All Statuses'
            return arr.map(v => {
              const option = SYNC_STATUS_OPTIONS.find(o => o.value === v)
              return option?.label || v
            }).join(', ')
          }}
        >
          {SYNC_STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox checked={selectedValues.includes(option.value)} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default SyncStatusField
